import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from '@layouts/Header';
import Footer from '@layouts/Footer';
import { Home } from './components/Home/index';
import About from '@components/About';
import TermsOfService from '@components/TermsOfService';
import './index.css';

function App() {
  return (
    <div className='App'>
      <Router>
        <Header />
        <div className='template-body'>
          <Routes>
            <Route exact path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/tos' element={<TermsOfService />} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
